const FORMAT_NATIONAL = "NATIONAL";
const FORMAT_INTERNATIONAL = "INTERNATIONAL";
const FORMAT_RFC3966 = "RFC3966";
const TYPE_MOBILE = "MOBILE";

const PHONE_NUMBER_MAX_LENGTH_REGEX_WITHOUT_PREFIX = {
    ES: /^(6|7|(6\d|7[1-4])\d{0,7})$/,
    PT: /^[9]\d{0,9}$/,
    DE: /^[+\d]{0,12}$/,
    NL: /^[+\d]{0,10}$/
};

const REMOVE_PREFIX_PHONE_COUNTRIES = ["NL", "DE"];

module.exports = {
    FORMAT_NATIONAL,
    FORMAT_INTERNATIONAL,
    FORMAT_RFC3966,
    PHONE_NUMBER_MAX_LENGTH_REGEX_WITHOUT_PREFIX,
    TYPE_MOBILE,
    REMOVE_PREFIX_PHONE_COUNTRIES
};
